<template>
    <el-drawer 
		title="汇总统计"
		:visible.sync="drawerShow"
		:wrapperClosable="false"
		:destroy-on-close="true"
		size="800px"
        @close="close">
        <div class="drawer-content" v-if="data && data.length >0 ">
			<div class="surveyName">{{name}}</div>
            <div class="page-list-box" v-for="(item, index) in data" >
				<div class="menuName">{{item.questionName}}</div>
				<el-table
				    :data="item.data"
				    border
				    style="width: 100%"
				    v-loading="listLoading"
				    size="small"
				    stripe
				>
				    <el-table-column prop="optionName" label="选项"></el-table-column>
					<el-table-column prop="userCount" label="人数"></el-table-column>
					<el-table-column prop="ratio" label="占比"></el-table-column>
				</el-table>
			</div>
			
        </div>
		<div class="empty" v-else>暂无数据</div>
        
    </el-drawer>
</template>
<script>

export default {
    props:{
	    id: {
	        type: [Number, String],
	        default: () => null
	    },
		name :{
			type: [Number, String],
			default: () => null
		}
		
	},
    data() {		
        return {
           drawerShow: false,
		   data:null
		   
        }
    },
	mounted() {
	   this.getData()
	},
    methods: {
        close() {            
			this.drawerShow = false;
        },
        show() {
            this.drawerShow = true;
			
        },
		//获取列表		
        getData() {			
            this.listLoading = true;
            this.$request({
                url: "/survey/summary",
                method: "POST",
                params: {
					id:this.id
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
		
		
	
		
    }
}
</script>

<style lang="scss" scoped>
.surveyName{
	margin-bottom: 10px;
	color: #000;
	font-size: 18px;
}
.menuName{
	margin-bottom: 10px;
	color: #000;
	font-size: 16px;
}
.empty{
	min-height: 300px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>